import { FormikProps } from 'formik/dist/types';
import * as Yup from 'yup';
import { ErrorWord, CommonData, yapStringWhen, EstablishPageType, yapNumberWhen } from '../common';

/*--------------
お勤め先情報
--------------*/
//職業のあれこれ
//リスト名
export enum Pofession {
  UNLISTED_COMPANY_EMPOYEE = '非上場会社の社員・団体の職員',
  UNLISTED_COMPANY_MANAGEMENT = '非上場会社・団体の執行役員・管理職',
  UNLISTED_COMPANY_OFFICER = '非上場会社・団体の役員',
  UNLISTED_COMPANY_OWNER = '非上場会社のオーナー経営者',
  LISTED_COMPANY_EMPOYEE = '上場会社の社員',
  LISTED_COMPANY_MANAGEMENT = '上場会社の執行役員・管理職',
  LISTED_COMPANY_OFFICER = '上場会社等の役員',
  GOVERNMENT_EMPLOYEE = '官公庁職員',
  TEACHER = '教職員',
  LAWYER = '弁護士',
  CERTIFIED_PUBLIC_ACCOUNTANT = '公認会計士',
  TAX_ACCOUNTANT = '税理士',
  JUDICAIAL_SCRIVENER = '司法書士',
  ADMINISTRATIVE_SCRIVENER = '行政書士',
  DOCTOR = '医師',
  CONSULTANT = 'コンサルタント',
  SELF_EMPLOYED = '自営業',
  TEMPORARY_EMPOYEE = '派遣社員',
  PART = 'パート・アルバイト',
  OTHER = 'その他',
  HOUSEWIFE = '専業主婦',
  STUDENT = '学生',
  UNEMPLOYED = '無職',
}
//{ id: number; value: string }[]のデータ作る
const PofessionList: CommonData[] = (Object.keys(Pofession) as (keyof typeof Pofession)[]).map((key, index) => {
  return { id: index + 1, value: Pofession[key] };
});
//string[]のデータ作る
export const PofessionStrs = PofessionList.map((data) => data.value);
//{ id: number; value: string }[]からリスト名でid取得する
export const finedPofessionId = (str: string) => {
  return PofessionList.find((data) => data.value === str)?.id;
};
//{ id: number; value: string }[]からidでリスト名取得する
export const finedPofessionStr = (id: number) => {
  return PofessionList.find((data) => data.id === id)?.value;
};

//役職のあれこれ
//リスト名
export enum ListedCompanyPost {
  OFFICER = '役員（取締役、会計参与、監査役もしくは執行役。退任後1年以内の方も含む）',
  MAJOR_SHAREHOLDER = '主要株主（総議決権の10％以上を有する株主）',
  OFFICER_FAMIRY = '役員（退任後の方は除く）の配偶者および同居者',
  TOP_MAJOR_SHAREHOLDER = '大株主（上位10位以内の株主）',
  OFFICER_ADVISOR = '執行役員、役員に準じる役職（相談役、顧問等）、または重要事実を知り得る可能性の高い部署に所属する従業者',
  PARENT_COMPANY_OFFICER = '親会社の役員（退任後1年以内の方も含む）、執行役員、役員に準じる役職、または重要事実を知り得る可能性の高い部署に所属する従業者',
  OFFICERS_OF_SUBSIDIARIES = '主な子会社等の役員（退任後1年以内の方も含む）、執行役員、役員に準じる役職、または重要事実を知り得る可能性の高い部署に所属する従業者',
}
//{ id: number; value: string }[]のデータ作る
const ListedCompanyPostList: CommonData[] = (Object.keys(ListedCompanyPost) as (keyof typeof ListedCompanyPost)[]).map(
  (key, index) => {
    return { id: index + 1, value: ListedCompanyPost[key] };
  },
);
//string[]のデータ作る
export const ListedCompanyPostStrs = ListedCompanyPostList.map((data) => data.value);
//{ id: number; value: string }[]からリスト名でid取得する
export const finedListedCompanyPostId = (str: string) => {
  return ListedCompanyPostList.find((data) => data.value === str)?.id;
};
//{ id: number; value: string }[]からidでリスト名取得する
export const finedListedCompanyPostStr = (id: number) => {
  return ListedCompanyPostList.find((data) => data.id === id)?.value;
};

//入力値の型
export type EmploymentType = {
  // ご職業
  profession: string; //Intに変換してリクエスト必要
  // お勤め先名称 or 屋号
  workplace: string;
  // お勤め先なし（これはリクエストに不要）
  isNoWorkplace: boolean;
  // 所属部署
  department: string;
  // 所属部署なし（これはリクエストに不要）
  isNoDepartment: boolean;
  // ご役職
  post: string;
  // 役職なし（これはリクエストに不要）
  isNoPost: boolean;
  // お勤め先電話番号
  workPhoneNumber: string;
  // お勤め先電話番号なし（これはリクエストに不要）
  isNoWorkPhoneNumber: boolean;
  // 上場企業該当者チェック
  listedCompanyCheck: boolean;
  // 上場会社等の役職等
  listedCompanyPost: string | null; //Intに変換してリクエスト必要
  // 上場会社名
  listedCompanyName: string | null;
  // 社外役員の場合のご役職
  outSidePost: string | null;
  // 退任日
  retirementDate: string | null; // 形式: yyyy/MM/dd
  // 役員（同居または伴侶）の氏名(名)
  insiderBoardMemberFirstName: string | null;
  // 役員（同居または伴侶）の氏名（姓）
  insiderBoardMemberLastName: string | null;
};
//Formik用の型
export type EmploymentFormikType = FormikProps<EmploymentType>;

//Formikに渡す初期値
export const employmentInitialValues = (param: EmploymentType) => {
  return {
    ...param,
    profession: param.profession || '',
    workplace: param.workplace || '',
    isNoWorkplace: param.isNoWorkplace ?? false,
    department: param.department || '',
    isNoDepartment: param.isNoDepartment ?? false,
    post: param.post || '',
    isNoPost: param.isNoPost ?? false,
    workPhoneNumber: param.workPhoneNumber || '',
    isNoWorkPhoneNumber: param.isNoWorkPhoneNumber ?? false,
    listedCompanyCheck: param.listedCompanyCheck ?? null,
    listedCompanyPost: param.listedCompanyPost ?? null,
    listedCompanyName: param.listedCompanyName ?? null,
    outSidePost: param.outSidePost ?? null,
    retirementDate: param.retirementDate ?? null,
    insiderBoardMemberFirstName: param.insiderBoardMemberFirstName ?? null,
    insiderBoardMemberLastName: param.insiderBoardMemberLastName ?? null,
  };
};

//バリデーション
//上場企業チェック用
const yapListedJudgeWhen = <T extends Yup.Schema>(yup: T, inversion: boolean, errorWord: string) =>
  yup.when(['listedCompanyCheck', 'listedCompanyPost'], {
    is: (check: boolean, post: string) => {
      if (check) {
        const b = post === ListedCompanyPost.OFFICER_FAMIRY;
        return inversion ? b : !b;
      }
      return false;
    },
    then: (schema) => schema.required(errorWord),
    otherwise: (schema) => schema.strip(),
  });
export const employmentValidation = Yup.object().shape({
  profession: Yup.string().required(ErrorWord.SELECT),
  workplace: yapStringWhen('isNoWorkplace', false, ErrorWord.INPUT),
  department: yapStringWhen('isNoDepartment', false, ErrorWord.INPUT),
  post: yapStringWhen('isNoPost', false, ErrorWord.INPUT),
  workPhoneNumber: Yup.string().when('isNoWorkPhoneNumber', {
    is: false,
    then: (schema) => schema.required(ErrorWord.PHONE_NUMBER).matches(/^[0-9]{10,11}$/gi, ErrorWord.PHONE_NUMBER),
    otherwise: (schema) => schema.strip(),
  }),
  listedCompanyCheck: Yup.bool().nonNullable(ErrorWord.SELECT),
  listedCompanyPost: yapStringWhen('listedCompanyCheck', true, ErrorWord.SELECT),
  listedCompanyName: yapStringWhen('listedCompanyCheck', true, ErrorWord.INPUT),
  insiderBoardMemberFirstName: yapListedJudgeWhen(Yup.string(), true, ErrorWord.INPUT),
  insiderBoardMemberLastName: yapListedJudgeWhen(Yup.string(), true, ErrorWord.INPUT),
  retirementDate: Yup.date()
    .nullable()
    .min(new Date('1900/1/1').toDateString(), ErrorWord.Date)
    .max(new Date().toDateString(), ErrorWord.Date),
});

//Formikのサブミットメソッド
export const employmentOnSubmit = <T>(param: T, add: (data: T) => void, cb?: () => void) => {
  return (values: EmploymentType) => {
    add({
      ...param,
      profession: values.profession,
      workplace: values.workplace,
      isNoWorkplace: values.isNoWorkplace,
      department: values.department,
      isNoDepartment: values.isNoDepartment,
      post: values.post,
      isNoPost: values.isNoPost,
      workPhoneNumber: values.workPhoneNumber,
      isNoWorkPhoneNumber: values.isNoWorkPhoneNumber,
      listedCompanyCheck: values.listedCompanyCheck,
      listedCompanyPost: values.listedCompanyPost,
      listedCompanyName: values.listedCompanyName,
      outSidePost: values.outSidePost,
      retirementDate: values.retirementDate,
      insiderBoardMemberFirstName: values.insiderBoardMemberFirstName,
      insiderBoardMemberLastName: values.insiderBoardMemberLastName,
    });
    cb && cb();
  };
};
